// rtk
export default {
    rtk1: 'No Positioning',
    rtk2: 'GPS positioning Poor',
    rtk3: 'RTK single point positioning',
    rtk4: 'RTK differential positioning',
    rtk5: 'RTK floating point positioning',
    rtk6: 'RTK fixed positioning',
    rtk7: 'GPS positioning',
}